module.exports = __webpack_public_path__ + "img/logo_bg_grey.7e3cdb1d.png";